module.exports = {
	"id": "BF",
	"name": "Burkina Faso",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.002449,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.007347,
			"11": 0.066123,
			"12": 0.002449,
			"13": 0.004898,
			"14": 0.004898,
			"15": 0.007347,
			"16": 0.004898,
			"17": 0.019592,
			"18": 0.009796,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.009796,
			"25": 0.007347,
			"26": 0.002449,
			"27": 0.036735,
			"28": 0.019592,
			"29": 0.124899,
			"30": 0.014694,
			"31": 0.031837,
			"32": 0.009796,
			"33": 0.014694,
			"34": 0.004898,
			"35": 0.007347,
			"36": 0.007347,
			"37": 0.007347,
			"38": 0.004898,
			"39": 0.004898,
			"40": 0.017143,
			"41": 0.002449,
			"42": 0.007347,
			"43": 0.036735,
			"44": 0.012245,
			"45": 0.02449,
			"46": 0.012245,
			"47": 0.02449,
			"48": 0.017143,
			"49": 0.257145,
			"50": 0.046531,
			"51": 0.477555,
			"52": 0.144491,
			"53": 6.462911,
			"54": 1.743688,
			"55": 0.007347,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.266941,
			"4": 0.012245,
			"5": 0.007347,
			"6": 0.002449,
			"7": 0.002449,
			"8": 0.002449,
			"9": null,
			"10": 0.007347,
			"11": 0.014694,
			"12": 0.026939,
			"13": 0.009796,
			"14": 0.004898,
			"15": 0.012245,
			"16": 0.02449,
			"17": 0.009796,
			"18": 0.014694,
			"19": 0.009796,
			"20": 0.046531,
			"21": 0.014694,
			"22": 0.007347,
			"23": 0.019592,
			"24": 0.053878,
			"25": 0.017143,
			"26": 0.031837,
			"27": 0.012245,
			"28": 0.019592,
			"29": 0.019592,
			"30": 0.056327,
			"31": 0.019592,
			"32": 0.063674,
			"33": 0.034286,
			"34": 0.029388,
			"35": 0.071021,
			"36": 0.046531,
			"37": 0.029388,
			"38": 0.044082,
			"39": 0.068572,
			"40": 0.044082,
			"41": 0.075919,
			"42": 0.093062,
			"43": 0.648985,
			"44": 0.124899,
			"45": 0.120001,
			"46": 0.09796,
			"47": 1.231847,
			"48": 0.957559,
			"49": 5.140451,
			"50": 0.105307,
			"51": 0.029388,
			"52": null,
			"3.5": 0.022041,
			"3.6": 0.012245
		},
		"opera": {
			"9": null,
			"11": 0.004898,
			"12": 0.004898,
			"15": 0.012245,
			"16": null,
			"17": 0.004898,
			"18": 0.007347,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.019592,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.014694,
			"36": 0.029388,
			"37": 0.04898,
			"38": 0.009796,
			"39": 0.041633,
			"40": 0.497147,
			"41": 0.051429,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.007347,
			"11.6": null,
			"12.1": 0.009796
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.012245,
			"6": 0.029388,
			"7": 0.031837,
			"8": 0.009796,
			"9": 0.161634,
			"10": 0.075919,
			"3.1": null,
			"3.2": null,
			"5.1": 0.007347,
			"6.1": 0.002449,
			"7.1": null,
			"9.1": 0.428575
		},
		"ios_saf": {
			"8": 0,
			"10": 0.516184096586,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0139105641132,
			"8.1-8.4": 0.0256991777685,
			"9.0-9.2": 0.0122601582015,
			"9.3": 0.187046003331
		},
		"android": {
			"3": 0,
			"4": 0.10161655814,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0127020697674,
			"4.1": 0.36654544186,
			"4.2-4.3": 0.916363604651,
			"4.4": 2.10128525581,
			"4.4.3-4.4.4": 2.11943106977
		},
		"ie": {
			"6": 0.007347,
			"7": 0.007347,
			"8": 0.230206,
			"9": 0.039184,
			"10": 0.183675,
			"11": 1.268582,
			"5.5": null
		},
		"op_mob": {
			"0": 3.09005296731,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0858348046475
		},
		"edge": {
			"12": 0.240002,
			"13": 0.193471,
			"14": 0.124899
		},
		"ie_mob": {
			"10": 0.0848689859155,
			"11": 0.345538014085
		},
		"bb": {
			"7": 0.03586725,
			"10": null
		},
		"samsung": {
			"0": 1.245915
		},
		"and_uc": {
			"0": 7.883244
		},
		"op_mini": {
			"0": 41.631746228
		},
		"and_chr": {
			"0": 14.228134
		},
		"and_ff": {
			"0": 0.07551
		}
	},
	"total": 98.46770525
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BF.json
 ** module id = 475
 ** module chunks = 0
 **/